import { render, staticRenderFns } from "./ListPartners.vue?vue&type=template&id=1b9eda17&"
import script from "./ListPartners.vue?vue&type=script&lang=js&"
export * from "./ListPartners.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports